import { useState } from 'react';
import { ButtonVariants } from '../../Atoms/Button';
import { MarktechModal } from '../../Atoms/Modal';
import { Pointers } from '../../income-tax/page-sections/hero-section/pointers-section';
import { ButtonWithAnchor } from '../../income-tax/page-sections/hero-section/sticky-button';
import { HERO_SECTION } from '../../income-tax/static/types';
import { startFilingLinkViewPlans } from '../static/data';
import { ViewPlanModalContent } from '../../income-tax/page-sections/hero-section/view-plan-modal-content';
import { ITR_2_PRICE_TABLE_BODY } from '../../Common/price-table/data';

interface IHERO_PROPS {
  data: HERO_SECTION;
}

export const Itr2Hero = ({ data }: IHERO_PROPS): JSX.Element => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const togglePlanModal = () => setIsPopupVisible(!isPopupVisible);

  return (
    <div className="relative">
      <img
        src="https://assets1.cleartax-cdn.com/finfo/wg-utils/webinars/5a26c5f0-7d20-4cae-8364-d8b2a20970f3.png"
        alt=""
        width={318}
        height={380}
        className="absolute left-0 top-10 bottom-0 sm:hidden md:hidden lg:pr-16"
      />
      <img
        src="https://assets1.cleartax-cdn.com/finfo/wg-utils/webinars/5ad5c167-af3f-4d48-b9ff-a0a2add994ed.png"
        alt=""
        width={318}
        height={380}
        className="absolute right-0  top-10 bottom-0 sm:hidden md:hidden lg:pl-16"
      />

      <div className="wg-container">
        <div className="pt-12 w-8/12 mx-auto md:w-full sm:w-full sm:pt-8 flex flex-col items-center sm:block">
          <span className="text-s-18 text-font-200 font-bold text-center sm:leading-close">
            ITR 2 Filing
          </span>
          <h1 className="text-center relative z-10 sm:text-left md:text-s-40 sm:text-s-36 text-s-56">
            <br />
            {data.title}
          </h1>

          <div className="px-16 flex flex-col items-center md:px-4 sm:px-0 sm:items-start">
            <div className="flex gap-8 pt-6 sm:flex-col sm:gap-3 items-start justify-between">
              {data.lists?.map((item, idx) => (
                <Pointers key={idx} item={item as string} />
              ))}
            </div>

            <div className="flex items-center gap-6 sm:w-full sm:mt-6 w-3/4">
              <ButtonWithAnchor
                buttonText="Start Filing"
                isStickyOnMobile={true}
                trackLabel={`hero_fold_button`}
                buttonVariant={ButtonVariants.bluefilled}
                className="my-12 mx-0 sm:my-0 w-full"
                buttonLink={startFilingLinkViewPlans}
              />

              <ButtonWithAnchor
                buttonText="View Plans"
                isStickyOnMobile={false}
                onClickHandler={() => togglePlanModal()}
                trackLabel={`hero_fold_button`}
                buttonVariant={ButtonVariants.bluebordered}
                className="my-12 mx-0 sm:my-0 w-[238px] sm:mt-3 sm:w-full"
              />

              <MarktechModal
                open={isPopupVisible}
                onClose={togglePlanModal}
                closeIcon={'✕'}
                classNames={{
                  modal:
                    'w-8/12 mobile-search-box rounded-2xl md:w-11/12 sm:w-11/12 h-fit max-h-[90vh] overflow-hidden',
                  closeIcon: 'absolute',
                }}
                center
              >
                <div
                  className="modal rounded-xl modal-open bg-[#EEF5FF]"
                  id="contact-sales"
                  data-fold-location="navbar_button_Book a demo"
                >
                  <ViewPlanModalContent
                    trackLabel="inpage_income_tax_efiling"
                    plansList={[
                      'prod_self_itr_2',
                      'prod_self_itr_3',
                      'prod_self_itr_7',
                      'prod_self_itr_6',
                    ]}
                    priceTableData={ITR_2_PRICE_TABLE_BODY}
                    buttonLink={startFilingLinkViewPlans}
                    priceMapData={{}}
                  />
                </div>
              </MarktechModal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
